import querystring from 'query-string'
import { generatePath } from 'react-router'
import { get, pickBy, isEmpty } from 'lodash'
import log from 'blazar-sentry'

import paths from 'routes/paths'
import slugify from 'utils/slugify'
import { getLabel, getTreeNodes } from 'utils/parameters'
import { CATEGORIES } from './constants'

export const buildAdUrl = (ad) => {
  try {
    if (get(ad, 'category[0].id') === CATEGORIES.EMPLOYMENT) {
      return ad.shareUrl
    }

    const region = ad.location[0].name
      .toLowerCase()
      .replace(/[åä]/g, 'a')
      .replace(/ö/g, 'o')

    const subject = ad.subject
      .toLowerCase()
      .replace(/[åä]/g, 'a')
      .replace(/ö/g, 'o')
      .replace(/\W/g, '_')

    return `/annons/${region}/${subject}/${ad.adId}`
  } catch (err) {
    log.error(new Error('Failed to buildAdUrl', err))
    return '/adout/404'
  }
}

export const buildListPathname = (query, byQueryKey) => {
  let category = ''
  let region = 'hela_sverige'

  if (query.r) {
    region = getLabel(byQueryKey.r, { r: query.r })
  }

  if (query.cg) {
    let categoryNodes = getTreeNodes(byQueryKey.cg, { cg: query.cg })
    // Slice off the "alla kategorier" node
    categoryNodes = categoryNodes.slice(1)

    const categoryLabels = categoryNodes.map((node) => slugify(node.label))
    category = `/${categoryLabels.join('/')}`
  }

  return `/annonser/${slugify(region)}${category}`
}

export function buildListQuerystring(query) {
  const queryWithoutNullValues = pickBy(query)
  if (!isEmpty(queryWithoutNullValues)) {
    return `?${querystring.stringify(queryWithoutNullValues)}`
  }
  return ''
}

export const buildListUrl = (query, parametersByQueryKey) => {
  const listPathName = buildListPathname(query, parametersByQueryKey)
  const listQuerystring = buildListQuerystring(query)
  return `${listPathName}${listQuerystring}`
}

export const buildStorePath = (storeName) => {
  if (!storeName) {
    return null
  }
  return generatePath(paths.Store, { storeName })
}

/**
 * This function enables testing for window.location.href
 */
const getCurrentUrl = () => window.location.href

export const isValidUrl = (str) => {
  /* eslint-disable-next-line */
  const regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/
  const pattern = new RegExp(regex)
  return pattern.test(str)
}
export default getCurrentUrl
